import fetchPersonaPhoto from '../actions/fetchPersonaPhoto';
import getInitial from '../utils/getInitial';
import getPersonaControlKey from '../utils/getPersonaControlKey';
import getTextBoyColor from '../utils/getTextBoyColor';
import openPeopleCard from 'mini-people-card/lib/utils/openPeopleCard';
import personaControlStore from '../store/Store';
import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Persona } from 'fabric-persona/lib/components/Persona';
import { PersonaControlProps } from './PersonaControl.types';
import { PersonaSize } from 'fabric-persona/lib/components/Persona.Props';

const PersonaControl = (props: PersonaControlProps) => {
    const fallbackRef = useRef<HTMLDivElement>(null);
    const {
        initialsCoinClassName,
        imageClassName,
        className,
        ariaLabel,
        ariaHidden,
        name = '',
        emailAddress = '',
        personaId,
        initialGenerationText,
        size = PersonaSize.regular,
        mailBoxType,
        personaSource,
        secondaryText,
        statusText,
        showPersonaDetails,
        showEmailAddress = true,
        meetingResponse,
        fetchPhotoOnCacheMiss = true,
        personaRef = fallbackRef,
        ariaHasPopup = false,
        imageUrl,
        hideInitials,
    } = props;
    const onClickFallback = () => {
        openPeopleCard(
            {
                Name: name,
                EmailAddress: emailAddress,
                MailboxType: mailBoxType,
            },
            (personaSource || 'PersonaControl') as string,
            'Persona'
        );
    };
    const { onClickPersona = onClickFallback } = props;

    useEffect(() => {
        fetchPhotoOnCacheMiss &&
            !imageUrl &&
            fetchPersonaPhoto(name, emailAddress, personaId, initialGenerationText ?? name, size);
    }, [fetchPhotoOnCacheMiss, name, emailAddress, personaId, initialGenerationText, size]);

    const personaControlKey = getPersonaControlKey(name, emailAddress, personaId, size);
    const viewState = personaControlStore.viewStates.get(personaControlKey);

    const photoDisplayProps = {
        imageUrl: imageUrl || viewState?.personaBlob?.blobUrl,
        imageShouldFadeIn: false,
        imageInitials: getInitial(name),
        initialsColor: getTextBoyColor(name),
    };

    const personaSecondaryText: string =
        secondaryText || secondaryText === '' ? secondaryText : emailAddress;

    return (
        <Persona
            key={personaControlKey}
            ref={personaRef}
            role="button"
            aria-label={ariaLabel}
            aria-hidden={ariaHidden ? 'true' : 'false'}
            aria-haspopup={ariaHasPopup}
            className={className}
            imageClassName={imageClassName}
            initialsCoinClassName={initialsCoinClassName}
            hidePersonaDetails={!showPersonaDetails}
            size={size}
            primaryText={name}
            secondaryText={personaSecondaryText}
            showSecondaryText={showEmailAddress}
            tertiaryText={statusText}
            onClickPersona={onClickPersona}
            meetingResponse={meetingResponse}
            hideInitials={hideInitials}
            {...photoDisplayProps}
        />
    );
};

export default observer(PersonaControl);
